import React from "react"
import { useIntl } from "react-intl"
import { benchmarkLegends } from "../../constants"
import { getBarColor, getFormattedDateRange } from "../../utils/utils"
import CircleLine from "../CircleLine/CircleLine"

interface LegendProps {
	filtersBenchmark: {
		period: string
		currentTo: string
		currentFrom: string
		previousTo: string
		previousFrom: string
	}
}

const WIDTH = 35
const HEIGHT = 10

const Legend: React.FC<LegendProps> = (props: LegendProps) => {
	const { filtersBenchmark } = props
	const periods = {
		startPreviousPeriod: filtersBenchmark.previousFrom,
		endPreviousPeriod: filtersBenchmark.previousTo,
		startCurrentPeriod: filtersBenchmark.currentFrom,
		endCurrentPeriod: filtersBenchmark.currentTo,
	}
	const intl = useIntl()

	return (
		<div className="legend">
			{benchmarkLegends.map((legend, index) => (
				<CircleLine
					key={`legend-footer-${index}`}
					width={WIDTH}
					height={HEIGHT}
					backgroundColor={getBarColor(legend.period)}
				>
					<p>
						{getFormattedDateRange(
							periods,
							filtersBenchmark.period,
							legend.period,
							intl
						)}
					</p>
				</CircleLine>
			))}
		</div>
	)
}

export default Legend
